import React from "react";

function Regulation() {
  return (
    <section id="regulation" className="organization-section">
      <h2>Regulamento</h2>
      <div className="regulation-container">
        <div className="organization-column">
          <h3>Composição das Equipas</h3>
          <p>
            As equipas participantes na MIUP são constituídas por, no máximo, 3
            elementos. Estes elementos devem respeitar as normas de
            elegibilidade do ICPC (ver Team Composition e Eligibility Decision
            Tree em{" "}
            <a href="https://icpc.global/regionals/rules">Regional Rules</a>).
            Estudantes que sejam já possuidores de um grau de pós-graduação (3º
            ciclo), bem como estudantes que tenham já participado em duas finais
            mundiais, não são elegíveis.
          </p>
          <p>
            Um estudante só pode concorrer por 1 instituição. Um membro da
            instituição representada deve comprovar a elegibilidade dos
            participantes. Cada equipa deverá ter um Treinador
            (preferencialmente não participante) que servirá de representante da
            equipa antes e durante o concurso.
          </p>
        </div>
        <div className="organization-column">
          <h3>Inscrição das Equipas</h3>
          <p>
            Cada Escola/Faculdade pode apresentar no máximo 2 equipas. Se houver
            mais do que 2 equipas de uma Escola/Faculdade, a organização irá
            aceitar as primeiras duas equipas a serem inscritas de forma
            regular. As inscrições das equipas têm que ser feitas
            obrigatoriamente no prazo definido pela organização. Poderá ser
            permitida a participação eventual de 3 ou 4 equipas da mesma
            Escola/Faculdade no caso de haver condições logísticas para tal. A
            escolha destas equipas ficará a cargo da organização da MIUP.
          </p>
          <p>
            A inscrição pode ser feita através do site do ICPC no seguinte{" "}
            <a href="https://icpc.global/regionals/finder/Maratona-Inter-Universitaria">
              link
            </a>
            , entre 1 e 21 de outubro de 2024.
          </p>
        </div>
        <div className="organization-column">
          <h3>Ambiente de trabalho</h3>
          <p>
            Cada equipa terá acesso a um computador, equipado de maneira
            semelhante ao das outras equipas. Cada equipa terá acesso aos
            compiladores de C, C++, Java e Python 3. Os programas deverão
            residir num ficheiro isolado e deverão obedecer às normas standard
            das linguagens. Será permitido o uso de STL no C++ e das packages de
            classes habituais do Java.
          </p>
        </div>
        <div className="organization-column">
          <h3>Material</h3>
          <p>
            As equipas estão impedidas de levar material em suporte informático
            ou calculadoras de bolso. Cada equipa pode ter no seu espaço da sala
            da competição um máximo de 25 páginas A4 impressas (não é aceite
            material manuscrito) com um tamanho de letra igual ou superior a 9.
            Cada elemento da equipa pode usar uma cópia exacta deste material. O
            material impresso tem que ser entregue ao júri da MIUP durante o
            processo de registo da equipa no dia da competição. Esse material
            será devolvido às equipas quando estas entrarem nas respectivas
            salas para a competição. Qualquer outro material de auxílio não será
            permitido, com exceção da documentação online disponível no ambiente
            da competição. A organização irá providenciar folhas A4 brancas e
            canetas. As equipas podem ainda trazer réguas e compassos, mas não
            podem utilizar outro material de escrita com excepção do fornecido
            pela organização.
          </p>
        </div>
        <div className="organization-column">
          <h3>Classificação</h3>
          <p>
            As equipas são classificadas de acordo com o número de problemas
            resolvidos. Em caso de empate, serão classificadas pelo somatório
            dos tempos dos problemas resolvidos. O tempo de um problema é igual
            ao tempo passado desde o início da prova até à sua submissão
            correcta mais uma penalização de 20 minutos por cada submissão
            errada para esse problema. Serão atribuídas uma medalha de ouro,
            duas de prata e três de bronze.
          </p>
        </div>
        <div className="organization-column">
          <h3>Desclassificação</h3>
          <p>
            Se uma equipa não cumprir com todos os pontos que constam do
            regulamento poderá ser desqualificada antes, durante ou depois da
            prova.
          </p>
        </div>
        <div className="organization-column">
          <h3>Recurso</h3>
          <p>
            Apenas a violação do regulamento ou desqualificações por má conduta
            são passíveis de recurso. As decisões do júri de aceitar ou rejeitar
            submissões são finais e não podem ser objecto de reclamação ou
            recurso. Os pedidos de recurso apenas podem ser apresentados pelos
            Treinadores das equipas.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Regulation;
